import Image from "next/image";
import type { ReactNode, Ref } from "react";
import { cn } from "@/lib/utils";
import { Glyph } from "./Glyph";
import type { GlyphName } from "./Glyph";
import { FOCUS_RING } from "./focusRing.constants";
export function RailRow({
  label,
  count,
  iconSrc,
  isSelected = false,
  isNested = false,
  onClick,
  onPointerEnter,
  className,
  ref
}: {
  label: ReactNode;
  count?: number;
  iconSrc?: string;
  isSelected?: boolean;
  isNested?: boolean;
  onClick: () => void;
  onPointerEnter?: () => void;
  className?: string;
  ref?: Ref<HTMLButtonElement>;
}) {
  return <button ref={ref} type="button" onClick={onClick} onPointerEnter={onPointerEnter} aria-current={isSelected ? "page" : undefined} data-rail-row={isNested ? "nested" : "top"} className={cn("mx-1.5 flex items-center gap-2 rounded-field px-2 text-left transition-colors", FOCUS_RING, isNested ? "py-1.5 pl-3 text-callout" : "py-[7px] text-callout font-medium", isSelected ? "bg-offwhite font-medium text-ink" : cn("hover:bg-offwhite/60", isNested ? "text-ink-2 hover:text-ink" : "text-ink"), className)} data-sentry-component="RailRow" data-sentry-source-file="RailRow.tsx">
            {iconSrc && <Image src={iconSrc} alt="" aria-hidden width={18} height={18} className="h-[18px] w-[18px] shrink-0 object-contain" />}
            <span data-rail-label className="min-w-0 flex-1 truncate">
                {label}
            </span>
            {count !== undefined && <span data-rail-count className={cn("font-mono text-caption font-normal tabular-nums", count === 0 ? "text-ink-3/60 dark:text-ink-3" : "text-ink-2")}>
                    {count.toLocaleString()}
                </span>}
        </button>;
}
export function RailGroup({
  children
}: {
  children: ReactNode;
}) {
  return <div className="ml-[23px] flex flex-col gap-px border-l border-ink/[0.1] py-0.5" data-sentry-component="RailGroup" data-sentry-source-file="RailRow.tsx">
            {children}
        </div>;
}
export function RailActionRow({
  glyph,
  label,
  title,
  onClick
}: {
  glyph: GlyphName;
  label: ReactNode;
  title?: string;
  onClick: () => void;
}) {
  return <button type="button" onClick={onClick} title={title} className={cn("mx-1.5 flex h-9 items-center gap-2.5 rounded-field px-2 text-left text-callout text-ink transition-colors hover:bg-offwhite/60", FOCUS_RING)} data-sentry-component="RailActionRow" data-sentry-source-file="RailRow.tsx">
            <span className="flex h-[22px] w-[22px] flex-shrink-0 items-center justify-center rounded-full bg-ink text-surface">
                <Glyph name={glyph} className="h-3 w-3" strokeWidth={2} data-sentry-element="Glyph" data-sentry-source-file="RailRow.tsx" />
            </span>
            <span className="min-w-0 flex-1 truncate">{label}</span>
        </button>;
}
export function RailHeading({
  children
}: {
  children: ReactNode;
}) {
  return <div data-rail-heading className="px-3.5 pb-1.5 pt-4 text-footnote text-ink-3" data-sentry-component="RailHeading" data-sentry-source-file="RailRow.tsx">
            {children}
        </div>;
}